export default __webpack_public_path__ + "static/media/general-information.5e86cdde.svg";